import React from 'react';
import { BOTTOM_NAVIGATION } from '../config/constant';
import { 
  Box, 
  Paper, 
  Typography, 
  Button, 
  Chip,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { 
  DirectionsBus,
  Search, 
  Timer,
  CompareArrows,
  AltRoute
} from '@mui/icons-material';
import { pushGA4CustomEvent } from '../Analytics';

function CardSearchBus(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = () => {
    // Track card click event
    pushGA4CustomEvent(
      "Search Bus Card Click",
      "searchBusCardClick",
      "Search bus feature accessed from homepage"
    );
    
    // Store the desired tab in sessionStorage
    sessionStorage.setItem('busTabView', 'search');
    
    // Set the bottom navigation to Bus tab
    props.updateBottomNavigationTab(BOTTOM_NAVIGATION.BUS);
    props.displayFullScreen(false);
  };

  return (
    <Paper
      elevation={2}
      onClick={handleClick}
      sx={{
        borderRadius: 3,
        overflow: 'hidden',
        mb: 1.5,
        position: 'relative',
        background: 'linear-gradient(135deg, #673ab7 0%, #5d4a7d 100%)',
        border: '1px solid rgba(255,255,255,0.1)',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        '&:hover': {
          boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
          transform: 'translateY(-2px)'
        }
      }}
    >
      {/* NEW feature badge */}
      <Chip
        label="NEW"
        size="small"
        sx={{
          position: 'absolute',
          top: 16,
          right: 16,
          backgroundColor: '#ff9800',
          color: 'white',
          fontWeight: 'bold',
          fontSize: '0.7rem',
          height: 24,
          px: 0.5,
          zIndex: 2
        }}
      />

      {/* Remove accent color bar since we have gradient background */}

      <Box sx={{ p: 3, color: 'white' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
          <Box
            sx={{
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderRadius: '50%',
              p: 1.5,
              mr: 2.5,
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <CompareArrows sx={{ fontSize: 28 }} />
          </Box>
          <Box>
            <Typography variant="h5" component="h2" fontWeight="600" sx={{ mb: 0.5 }}>
              Find Your Bus
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.9 }}>
              See all buses going from one stop to another
            </Typography>
          </Box>
        </Box>

        {/* Feature highlights */}
        <Box 
          sx={{ 
            display: 'flex', 
            flexWrap: 'wrap', 
            gap: 2, 
            mb: 3, 
            mt: 3,
            justifyContent: isMobile ? 'center' : 'flex-start'
          }}
        >
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderRadius: 30,
              px: 2,
              py: 1,
              color: 'white'
            }}
          >
            <DirectionsBus sx={{ fontSize: 18, mr: 1 }} />
            <Typography variant="body2" fontWeight="500">
              All Bus Routes
            </Typography>
          </Box>
          
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderRadius: 30,
              px: 2,
              py: 1,
              color: 'white'
            }}
          >
            <AltRoute sx={{ fontSize: 18, mr: 1 }} />
            <Typography variant="body2" fontWeight="500">
              Easy to Use
            </Typography>
          </Box>
          
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center',
              backgroundColor: 'rgba(255,255,255,0.15)',
              borderRadius: 30,
              px: 2,
              py: 1,
              color: 'white'
            }}
          >
            <Timer sx={{ fontSize: 18, mr: 1 }} />
            <Typography variant="body2" fontWeight="500">
              Choose Time
            </Typography>
          </Box>
        </Box>

        <Button
          variant="outlined"
          disableElevation
          onClick={(e) => {
            e.stopPropagation(); // Prevent click from bubbling to parent
            handleClick();
          }}
          fullWidth
          startIcon={<Search sx={{ fontSize: 20 }} />}
          sx={{
            mt: 1,
            py: 1.5,
            backgroundColor: 'rgba(255,255,255,0.15)',
            borderColor: 'rgba(255,255,255,0.3)',
            color: 'white',
            textTransform: 'none',
            fontWeight: 'bold',
            fontSize: '1rem',
            borderRadius: 8,
            '&:hover': {
              backgroundColor: 'rgba(255,255,255,0.25)',
              borderColor: 'rgba(255,255,255,0.5)'
            }
          }}
        >
          Find Buses
        </Button>
      </Box>
    </Paper>
  );
}

export default CardSearchBus; 